<template>
  <Loader v-if="this.$store.state.isLoading" />
  <div class="blog-section">
    <p class="blog-header">Read Our Blogs Here</p>
    <div class="row">
      <div
        v-for="(post, index) in blogPosts"
        :key="index"
        class="col-6 col-md-4 col-lg-3 card-col"
      >
        <Card :post="post" :number="index" />
      </div>
    </div>
  </div>
</template>

<script>
import Card from "../components/CardComponent.vue";
import Pagination from "../components/Pagination.vue";
import Loader from "../components/Loader.vue";
export default {
  name: "Blogs",
  computed: {
    blogPosts() {
      return this.$store.state.blogPosts;
    },
  },
  components: { Card, Pagination, Loader },
};
</script>

<style scoped>
.blog-section {
  flex-grow: 1;
  background-color: #f1f1f1;
}
.blog-header {
  font-size: 36px;
  margin-top: 30px;
}
.card-col {
  display: flex;
  justify-content: center;
}
@media (min-width: 1650px) {
  .blog-section {
    padding-left: 250px;
    padding-right: 250px;
  }
}

@media only screen and (min-width: 1251px) and (max-width: 1649px) {
  .blog-section {
    padding-left: 150px;
    padding-right: 150px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1250px) {
  .blog-section {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media (max-width: 599px) {
  .blog-section {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>